import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[commonTextareaAutoExpand]',
})
export class TextareaAutoExpandDirective {
  @HostListener('keyup', ['$event']) onKeyUp(event: any) {
    if (!event.target) return;
    event.target.style.height = '1px';
    event.target.style.height = event.target.scrollHeight + 'px';
  }
}
